import * as Constants from '../constants/authorized-users';

const initialState = {
  authorizedUser: {},
  activeAuthorizedUserId: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.GET_AUTHORIZED_USER_SUCCESS:
      return {
        ...state,
        authorizedUser: action.payload,
      };
    case Constants.UPDATE_AUTHORIZED_USER_SUCCESS:
      return {
        ...state,
        authorizedUser: action.payload,
      };
    case Constants.DELETE_AUTHORIZED_USER_SUCCESS:
      return {
        ...state,
        authorizedUser: action.payload,
      };
    case Constants.SET_ACTIVE_AUTHORIZED_USER:
      return {
        ...state,
        activeAuthorizedUserId: action.payload,
      };
    default:
      return state;
  }
};
